import {Pipe, PipeTransform} from '@angular/core';
import {TemplatePermissionsService} from 'app/global/permissions/template-permissions-service';
import {map, Observable} from 'rxjs';
import {IUserResultT} from '../contract-control/contract-control.permission.service';
import {AccessLevelEnum, AccessLevelPriority} from '../users/roles/roles.service';

@Pipe({
  name: 'templatePermission',
})
export class TemplatePermissionPipe implements PipeTransform {

  constructor (private _templatePermissionService: TemplatePermissionsService) {}

  /**
   * Transforms the given document type ID, user result, and required access level into an observable
   * that emits a boolean indicating whether the user has the required access level.
   *
   * @param id  - The ID of the template.
   * @param documentTypeId - The ID of the document type.
   * @param categoryIds  - The ID of the category or array of category IDs.
   * @param result - The user result object containing user information.
   * @param requiredAccessLevel - The required access level to check against.
   * @returns An observable that emits a boolean indicating whether the user has the required access level.
   */
  transform(id:number, documentTypeId: number, categoryIds: number | number[], result: IUserResultT, requiredAccessLevel: AccessLevelEnum): Observable<boolean> {
     return this._templatePermissionService.verifyPermission(id, documentTypeId, categoryIds, result).pipe(
      map(accessLevel => {
       return accessLevel!=null  &&  this.hasHigherAccessLevel(accessLevel, requiredAccessLevel, AccessLevelPriority);
      })
   );
  }

  private hasHigherAccessLevel(currentAccessLevel: AccessLevelEnum, requiredAccessLevel: AccessLevelEnum, accessLevels:AccessLevelEnum[]): boolean {
    const currentIndex = accessLevels.indexOf(currentAccessLevel);
    const requiredIndex = accessLevels.indexOf(requiredAccessLevel);

    if (currentIndex === -1 || requiredIndex === -1) {
      return false;
    }

    return currentIndex <= requiredIndex;
  }
}